import { add } from 'Common/Helpers/currency';

import { DENOMINATIONS } from '../constants';

export const computeCash = denominations =>
  Object.keys(denominations).reduce((accumulator, k) => {
    // Avoid calculating totals using fractions of a given denomination
    const normalizedCount = Math.round(denominations[k]);
    const total = normalizedCount * DENOMINATIONS[k].value;
    return add(accumulator, total);
  }, 0);

export const computeChecks = checks =>
  checks.reduce((accumulator, c) => {
    return add(accumulator, c.amount);
  }, 0);

/**
 * @param {Object} denominations the denominations
 * @param {Array{Object}} checks the checks list
 */
export const computeTotal = (denominations, checks) => {
  const cashTotal = computeCash(denominations);
  const checksTotal = computeChecks(checks);

  return (add(cashTotal, checksTotal) || 0).toFixed(2);
};



// WEBPACK FOOTER //
// ./src/common/Components/CashCalculator/helpers/compute.js